// @ts-nocheck
// import useOverlayBadge from "@insite/client-framework/Common/Hooks/useOverlayBadge"; // Starter Custom Code
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setSelectedImageIndex from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/SetSelectedImageIndex";
import { getSelectedImage } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import { ImageModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
/* Starter Custom Code
import ProductImageCarousel, {
    ProductImageCarouselStyles,
} from "@insite/content-library/Components/ProductImageCarousel";
*/
import ProductPrimaryImage, { ProductPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
// import Badge from "@insite/mobius/Badge";// Starter Custom Code
import { LazyImageProps } from "@insite/mobius/LazyImage";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import getNumberTextField from "@store/Framework/Common/Fields/Toolkit/numberText";
import Badge from "@store/MobiusOverrides/Badge/Badge";
import { getItemsPerSlideFromFieldValue } from "@store/Overrides/Components/Carousel";
import ProductImageCarousel, {
    productImageCarouselImageWidth,
    ProductImageCarouselStyles,
} from "@store/Overrides/Components/ProductImageCarousel";
import { imageStyles } from "@store/Themes/common/mixins/image";
import { badgeProps } from "@store/Themes/common/props/badge";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import useOverlayBadge from "@toolkit/Modules/client-framework/Common/Hooks/useOverlayBadge";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { useMemo } from "react";

/* Store Custom Code - Start */
import ProductAddToListLink from "@store/Overrides/Components/ProductAddToListLink";
/* Store Custom Code - End */

const zoomMaxsize = 95;
const zoomCarouselSpacing = pxToRem(16);

const enum fields {
    numberOfVisibleThumbnails = "numberOfVisibleThumbnails",
    showCarousel = "showCarousel",
}

const imagesPerRowField = getNumberTextField(fields.numberOfVisibleThumbnails, { integer: true, min: 1 });

interface OwnProps extends WidgetProps {
    fields: {
        [fields.numberOfVisibleThumbnails]: string;
        [fields.showCarousel]?: boolean;
    };
}
/* Starter Custom Code - End */

type Props = OwnProps /* Starter Custom Code */ &
    HasProductContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProductContext) => ({
    selectedImage: getSelectedImage(state, ownProps.productContext.product),
    selectedImageIndex: state.pages.productDetails.selectedImageIndex,
});

const mapDispatchToProps = {
    setSelectedImageIndex,
};

export interface ProductDetailsPrimaryImageStyles {
    /**
     * @deprecated Use primaryImage styles instead.
     */
    centeringWrapper?: InjectableCss;
    hiddenWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    image?: LazyImageProps;

    primaryImage?: ProductPrimaryImageStyles;
    fullPrimaryImageModal?: ModalPresentationProps;
    fullPrimaryImage?: ProductPrimaryImageStyles;
    imageCarousel?: ProductImageCarouselStyles;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeImageWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
    // Store Custom Code
    wrapper?: InjectableCss;
    addToListWrapper?: InjectableCss;
}

export const primaryImageStyles: ProductDetailsPrimaryImageStyles = {
    fullPrimaryImageModal: {
        closeButtonIconProps: {
            css: css`
                ${x => x.theme.modal.defaultProps?.closeButtonIconProps?.css}
                top: 0 !important;
            `,
        },
        closeButtonProps: {
            css: css`
                ${x => x.theme.modal.defaultProps?.closeButtonProps?.css}
                display: flex;
                padding: ${pxToRem(7)} !important;
                margin: 0 !important;
            `,
        },
        cssOverrides: {
            modalContainer: css`
                width: auto;
            `,
            modalBody: css`
                width: auto;
                height: auto !important;
                max-width: ${zoomMaxsize}vw !important;
                max-height: ${zoomMaxsize}vh !important;
                margin: 0 !important;
            `,
            modalTitle: css`
                position: absolute;
                top: 0;
                right: 0;
                z-index: 1;
                padding: 0;
                border-bottom: none;
                background-color: ${getColor("common.background")};
                box-shadow: ${x => x.theme.shadows.e40};
            `,
            modalContent: css`
                text-align: center;
                padding: 0;
            `,
        },
    },
    fullPrimaryImage: {
        centeringWrapper: {
            css: css`
                margin: 0;
            `,
        },
        img: {
            css: css`
                cursor: default;
                display: block;
                width: auto;
                height: auto;
                margin: 0 auto;
                max-height: ${zoomMaxsize}vh;
                max-width: ${zoomMaxsize}vw;
            `,
        },
    },
    imageCarousel: {
        mainWrapper: {
            css: css`
                width: 100%;
                height: auto;
                padding: ${zoomCarouselSpacing};
            `,
        },
    },
    primaryImage: {
        centeringWrapper: {
            css: css`
                ${x => imageStyles(x.theme.design.product.image.medium.ratio)}
                max-height: ${pxToRem(400)};
                margin: 0 auto;
            `,
        },
        img: {
            css: css`
                ${focusStyles(true)}
                cursor: zoom-in;
            `,
        },
    },
    badgeAreaWrapper: badgeProps.badgeAreaWrapper,
    badgeTextWrapper: badgeProps.badgeTextWrapper,
    badgeText: badgeProps.badgeText,
    badgeImageWrapper: badgeProps.badgeImageWrapper,
    // Store Custom Code
    wrapper: {
        css: css`
            position: relative;
        `,
    },
    addToListWrapper: {
        css: css`
            position: absolute;
            top: ${pxToRem(8)};
            right: ${pxToRem(8)};
        `,
    },
};

const styles = primaryImageStyles;

const ProductDetailsPrimaryImage = ({
    productContext,
    selectedImage,
    selectedImageIndex,
    setSelectedImageIndex,
    // Starter Custom Code
    fields: { numberOfVisibleThumbnails, showCarousel },
}: Props) => {
    const [fullPrimaryImageModalIsOpen, setFullImageModalIsOpen] = useState(false);
    const imageClickHandler = () => {
        setFullImageModalIsOpen(true);
    };
    const fullPrimaryImageModalCloseHandler = () => {
        setFullImageModalIsOpen(false);
    };

    const selectImageHandler = (index: number) => {
        setSelectedImageIndex({ index });
    };

    const { product } = productContext;
    const canAddToList = product.canAddToWishlist; // Store Custom Code

    /* Starter Custom Code - Start */
    const imagesPerRow = getItemsPerSlideFromFieldValue(numberOfVisibleThumbnails, imagesPerRowField.parse);
    const hasZoomCarousel = Boolean(product.images && product.images.length > 1 && showCarousel);

    const fullPrimaryImageStyles = useMemo(() => {
        if (!hasZoomCarousel) {
            return styles.fullPrimaryImage;
        }

        return mergeProps<ProductDetailsPrimaryImageStyles["fullPrimaryImage"]>(styles.fullPrimaryImage, {
            img: {
                css: css`
                    padding-bottom: calc(${productImageCarouselImageWidth} + (${zoomCarouselSpacing} * 2));
                `,
            },
        });
    }, [hasZoomCarousel, styles.fullPrimaryImage]);

    const imageCarouselStyles = useMemo(() => {
        if (!hasZoomCarousel) {
            return styles.imageCarousel;
        }

        return mergeProps<ProductDetailsPrimaryImageStyles["imageCarousel"]>(styles.imageCarousel, {
            mainWrapper: {
                css: css`
                    margin-top: calc(-${productImageCarouselImageWidth} - (${zoomCarouselSpacing} * 2));
                `,
            },
        });
    }, [hasZoomCarousel, styles.imageCarousel]);
    /* Starter Custom Code - End */

    if (!product) {
        return null;
    }

    const image =
        selectedImage ??
        ({
            id: product.id,
            imageAltText: product.imageAltText,
            imageType: "Static",
            largeImagePath: product.largeImagePath,
            mediumImagePath: product.mediumImagePath,
            smallImagePath: product.smallImagePath,
        } as ImageModel);

    const {
        showOverlayBadge,
        overlayBadge,
        overlayBadgeWrapperStyles,
        badgeAreaWrapperRef,
        overlayBadgeWrapperClickHandler,
    } = useOverlayBadge({
        productContext,
        showTextBadge: true,
        showImageBadge: true,
        styles,
    });

    const path = image.mediumImagePath || image.largeImagePath;
    if (!path) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} /* Store Custom Code */>
            {!showOverlayBadge && (
                <ProductPrimaryImage
                    product={product}
                    image={image}
                    onClick={imageClickHandler}
                    extendedStyles={styles.primaryImage}
                />
            )}
            {showOverlayBadge && overlayBadge && (
                <StyledWrapper {...styles.badgeAreaWrapper} ref={badgeAreaWrapperRef}>
                    <ProductPrimaryImage
                        product={product}
                        image={image}
                        onClick={imageClickHandler}
                        extendedStyles={styles.primaryImage}
                    />
                    <StyledWrapper {...overlayBadgeWrapperStyles} onClick={overlayBadgeWrapperClickHandler}>
                        <Badge
                            type={overlayBadge.badgeType}
                            value={
                                overlayBadge.badgeType === "Image"
                                    ? overlayBadge.largeImageBadgePath
                                    : overlayBadge.displayText
                            }
                            badgeTextColor={overlayBadge.textColorHexCode}
                            badgeBackgroundColor={overlayBadge.badgeColorHexCode}
                            badgeTextRounding={overlayBadge.badgeStyle === "Round"} // Starter Custom Code
                            imageAltText={overlayBadge.imageAltText ? overlayBadge.imageAltText : overlayBadge.name}
                            textBadgeCss={styles.badgeText}
                            imageBadgeProps={styles.badgeImageProps}
                        />
                    </StyledWrapper>
                </StyledWrapper>
            )}
            {/* Store Custom Code - Start */}
            {canAddToList && (
                <StyledWrapper {...styles.addToListWrapper}>
                    <ProductAddToListLink showTitle={true} showIcon={true} />
                </StyledWrapper>
            )}
            {/* Store Custom Code - End */}
            <Modal
                {...styles.fullPrimaryImageModal}
                isOpen={fullPrimaryImageModalIsOpen}
                handleClose={fullPrimaryImageModalCloseHandler}
            >
                <ProductPrimaryImage
                    product={product}
                    image={image}
                    useLargeImage={true}
                    extendedStyles={fullPrimaryImageStyles /* Starter Custom Code */}
                />
                {hasZoomCarousel /* Starter Custom Code */ && (
                    <ProductImageCarousel
                        selectedIndex={selectedImageIndex}
                        onSelectImage={selectImageHandler}
                        extendedStyles={imageCarouselStyles} // Starter Custom Code
                        numberOfVisibleThumbnails={imagesPerRow} // Starter Custom Code
                    />
                )}
            </Modal>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsPrimaryImage)),
    definition: {
        displayName: "Primary Image",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        /* Starter Custom Code - Start */
        fieldDefinitions: [
            {
                name: fields.showCarousel,
                displayName: "Show thumbnails during zoom",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                ...imagesPerRowField.definition,
                displayName: "Number Of Visible Thumbnails",
                defaultValue: "",
                fieldType: "General",
                isVisible: x => x.fields.showCarousel,
            },
        ],
        /* Starter Custom Code - End */
    },
};

export default widgetModule;
